function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.async-iterator.js";
import "core-js/modules/es.symbol.has-instance.js";
import "core-js/modules/es.symbol.is-concat-spreadable.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.symbol.match.js";
import "core-js/modules/es.symbol.replace.js";
import "core-js/modules/es.symbol.search.js";
import "core-js/modules/es.symbol.species.js";
import "core-js/modules/es.symbol.split.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.symbol.to-string-tag.js";
import "core-js/modules/es.symbol.unscopables.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.copy-within.js";
import "core-js/modules/es.array.every.js";
import "core-js/modules/es.array.fill.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.flat.js";
import "core-js/modules/es.array.flat-map.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.last-index-of.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.of.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.array.reduce-right.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.some.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.species.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.array.unscopables.flat.js";
import "core-js/modules/es.array.unscopables.flat-map.js";
import "core-js/modules/es.array-buffer.constructor.js";
import "core-js/modules/es.array-buffer.is-view.js";
import "core-js/modules/es.array-buffer.slice.js";
import "core-js/modules/es.data-view.js";
import "core-js/modules/es.date.now.js";
import "core-js/modules/es.date.to-iso-string.js";
import "core-js/modules/es.date.to-json.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.function.bind.js";
import "core-js/modules/es.function.has-instance.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.json.to-string-tag.js";
import "core-js/modules/es.map.js";
import "core-js/modules/es.math.acosh.js";
import "core-js/modules/es.math.asinh.js";
import "core-js/modules/es.math.atanh.js";
import "core-js/modules/es.math.cbrt.js";
import "core-js/modules/es.math.clz32.js";
import "core-js/modules/es.math.cosh.js";
import "core-js/modules/es.math.expm1.js";
import "core-js/modules/es.math.fround.js";
import "core-js/modules/es.math.hypot.js";
import "core-js/modules/es.math.imul.js";
import "core-js/modules/es.math.log10.js";
import "core-js/modules/es.math.log1p.js";
import "core-js/modules/es.math.log2.js";
import "core-js/modules/es.math.sign.js";
import "core-js/modules/es.math.sinh.js";
import "core-js/modules/es.math.tanh.js";
import "core-js/modules/es.math.to-string-tag.js";
import "core-js/modules/es.math.trunc.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.number.epsilon.js";
import "core-js/modules/es.number.is-finite.js";
import "core-js/modules/es.number.is-integer.js";
import "core-js/modules/es.number.is-nan.js";
import "core-js/modules/es.number.is-safe-integer.js";
import "core-js/modules/es.number.max-safe-integer.js";
import "core-js/modules/es.number.min-safe-integer.js";
import "core-js/modules/es.number.parse-float.js";
import "core-js/modules/es.number.parse-int.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.number.to-precision.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.object.create.js";
import "core-js/modules/es.object.define-getter.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.define-setter.js";
import "core-js/modules/es.object.entries.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.from-entries.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.get-own-property-names.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.object.is.js";
import "core-js/modules/es.object.is-extensible.js";
import "core-js/modules/es.object.is-frozen.js";
import "core-js/modules/es.object.is-sealed.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.lookup-getter.js";
import "core-js/modules/es.object.lookup-setter.js";
import "core-js/modules/es.object.prevent-extensions.js";
import "core-js/modules/es.object.seal.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.parse-float.js";
import "core-js/modules/es.parse-int.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.promise.finally.js";
import "core-js/modules/es.reflect.apply.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.reflect.define-property.js";
import "core-js/modules/es.reflect.delete-property.js";
import "core-js/modules/es.reflect.get.js";
import "core-js/modules/es.reflect.get-own-property-descriptor.js";
import "core-js/modules/es.reflect.get-prototype-of.js";
import "core-js/modules/es.reflect.has.js";
import "core-js/modules/es.reflect.is-extensible.js";
import "core-js/modules/es.reflect.own-keys.js";
import "core-js/modules/es.reflect.prevent-extensions.js";
import "core-js/modules/es.reflect.set.js";
import "core-js/modules/es.reflect.set-prototype-of.js";
import "core-js/modules/es.regexp.constructor.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.flags.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.string.code-point-at.js";
import "core-js/modules/es.string.ends-with.js";
import "core-js/modules/es.string.from-code-point.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.string.pad-end.js";
import "core-js/modules/es.string.pad-start.js";
import "core-js/modules/es.string.raw.js";
import "core-js/modules/es.string.repeat.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.string.starts-with.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.string.trim-end.js";
import "core-js/modules/es.string.trim-start.js";
import "core-js/modules/es.string.anchor.js";
import "core-js/modules/es.string.big.js";
import "core-js/modules/es.string.blink.js";
import "core-js/modules/es.string.bold.js";
import "core-js/modules/es.string.fixed.js";
import "core-js/modules/es.string.fontcolor.js";
import "core-js/modules/es.string.fontsize.js";
import "core-js/modules/es.string.italics.js";
import "core-js/modules/es.string.link.js";
import "core-js/modules/es.string.small.js";
import "core-js/modules/es.string.strike.js";
import "core-js/modules/es.string.sub.js";
import "core-js/modules/es.string.sup.js";
import "core-js/modules/es.typed-array.float32-array.js";
import "core-js/modules/es.typed-array.float64-array.js";
import "core-js/modules/es.typed-array.int8-array.js";
import "core-js/modules/es.typed-array.int16-array.js";
import "core-js/modules/es.typed-array.int32-array.js";
import "core-js/modules/es.typed-array.uint8-array.js";
import "core-js/modules/es.typed-array.uint8-clamped-array.js";
import "core-js/modules/es.typed-array.uint16-array.js";
import "core-js/modules/es.typed-array.uint32-array.js";
import "core-js/modules/es.typed-array.copy-within.js";
import "core-js/modules/es.typed-array.every.js";
import "core-js/modules/es.typed-array.fill.js";
import "core-js/modules/es.typed-array.filter.js";
import "core-js/modules/es.typed-array.find.js";
import "core-js/modules/es.typed-array.find-index.js";
import "core-js/modules/es.typed-array.for-each.js";
import "core-js/modules/es.typed-array.from.js";
import "core-js/modules/es.typed-array.includes.js";
import "core-js/modules/es.typed-array.index-of.js";
import "core-js/modules/es.typed-array.iterator.js";
import "core-js/modules/es.typed-array.join.js";
import "core-js/modules/es.typed-array.last-index-of.js";
import "core-js/modules/es.typed-array.map.js";
import "core-js/modules/es.typed-array.of.js";
import "core-js/modules/es.typed-array.reduce.js";
import "core-js/modules/es.typed-array.reduce-right.js";
import "core-js/modules/es.typed-array.reverse.js";
import "core-js/modules/es.typed-array.set.js";
import "core-js/modules/es.typed-array.slice.js";
import "core-js/modules/es.typed-array.some.js";
import "core-js/modules/es.typed-array.sort.js";
import "core-js/modules/es.typed-array.subarray.js";
import "core-js/modules/es.typed-array.to-locale-string.js";
import "core-js/modules/es.typed-array.to-string.js";
import "core-js/modules/es.weak-map.js";
import "core-js/modules/es.weak-set.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.immediate.js";
import "core-js/modules/web.queue-microtask.js";
import "core-js/modules/web.timers.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url.to-json.js";
import "core-js/modules/web.url-search-params.js";
import 'regenerator-runtime/runtime';
import 'url-search-params-polyfill';
import smoothscroll from 'smoothscroll-polyfill';
import './polyfills';
import 'intersection-observer';
import Vue from 'vue';
import axios from 'axios';
import { mask } from 'vue-the-mask';
import { sync, call, get } from 'vuex-pathify';
import PortalVue from 'portal-vue';
import components from '../../components';
import vuetify from './plugins/vuetify';
import store from './store';
import './filters';
Vue.use(PortalVue);
window.axios = axios;

function getCookie(name) {
  var value = "; ".concat(document.cookie);
  var parts = value.split("; ".concat(name, "="));

  if (parts.length === 2) {
    return parts.pop().split(';').shift();
  }

  return '';
}

function checkGeoIp() {
  var countryListAllowed = window.countryListAllowed || [];
  var geoIp = getCookie('geoIp');
  var isAllowed = countryListAllowed.some(function (_ref) {
    var value = _ref.value;
    return value === geoIp;
  });

  if (isAllowed) {
    document.body.classList.add('show-restricted');
  }
}

function checkPersistedData() {
  if (!document.querySelector('.formlinkcards')) {
    // only run on the dashboard
    return;
  }

  if (!document.querySelector('.info-overlay.open')) {
    // only run if there's an open info overlay
    return;
  }

  var vuex = window.localStorage.vuex;

  if (!vuex) {
    return;
  }

  var _JSON$parse = JSON.parse(vuex),
      forms = _JSON$parse.forms;

  var formName = forms.formName,
      formOccupation = forms.formOccupation,
      totalSteps = forms.totalSteps;

  if (formName === 'temperature-excursion') {
    if (formOccupation === 'patientCaregiver') {
      window.digitalData.page.formInfo.formName = "".concat(formName, "_").concat(formOccupation);
    } else {
      window.digitalData.page.formInfo.formName = "".concat(formName, "_other");
    }
  } else {
    window.digitalData.page.formInfo.formName = formName;
  }

  window.digitalData.page.formInfo.formProgress = _objectSpread(_objectSpread({}, window.digitalData.page.formInfo.formProgress), {}, {
    step: String(totalSteps),
    totalSteps: String(totalSteps)
  });
}

function checkFooterHeight() {
  if (!document.querySelector('main.dashboard') || !document.querySelector('footer.footer')) {
    return;
  }

  if (document.documentElement.style.getPropertyValue('--footerHeight') === '') {
    window.addEventListener('resize', checkFooterHeight);
  }

  var footerHeight = document.querySelector('footer.footer').offsetHeight;
  document.documentElement.style.setProperty('--footerHeight', "".concat(footerHeight, "px"));
}

function windowObjectsExist() {
  if (window.digitalData && window.digitalData.page && window.countryList) {
    return true;
  }

  return false;
}

function startApp() {
  checkGeoIp();
  checkPersistedData();
  checkFooterHeight();

  if (window.digitalData.page.formInfo && window.digitalData.page.formInfo.formProgress) {
    window.analytics = window.digitalData.page.formInfo.formProgress;
  }

  components.forEach(function (component) {
    if (component.register) component.register();
  });
  var elements = document.querySelectorAll('[data-vue-component]');
  [].forEach.call(elements, function (el) {
    el.dataset.initialized = 'true'; // eslint-disable-next-line no-new

    new Vue({
      el: el,
      vuetify: vuetify,
      store: store,
      data: {
        countryList: window.countryList || [],
        countryListAllowed: window.countryListAllowed || [],
        countryPIList: window.countryPIList || [],
        countryPIListAllowed: window.countryPIListAllowed || []
      },
      directives: {
        mask: mask
      },
      computed: {
        labels: sync('forms/labels'),
        title: sync('forms/title'),
        files: sync('forms/files'),
        products: sync('forms/products'),
        needLocation: get('needLocation'),
        loading: get('loading'),
        showCountrySelector: sync('showCountrySelector'),
        showConfirmPanel: sync('showConfirmPanel'),
        form: sync('forms/form'),
        countries: get('forms/countries'),
        countryPIListToDisplay: function countryPIListToDisplay() {
          var _this = this;

          if (this.countries === 'all') {
            return this.countryList;
          }

          var countriesToDisplay = this.countryList.filter(function (country) {
            return country.value === _this.countries;
          });

          if (typeof countriesToDisplay === 'undefined' || countriesToDisplay.length === 0) {
            return this.countryList;
          }

          return countriesToDisplay;
        },
        rules: function rules() {
          var _this2 = this;

          return {
            date: function date(value) {
              if (!value) return true;
              var dateParts = value.split('/');
              var date = new Date("".concat(dateParts[1], "/").concat(dateParts[0], "/").concat(dateParts[2]));
              return !Number.isNaN(date.getTime()) || _this2.labels.ruleInvalidDateFormat;
            },
            // eslint-disable-next-line no-confusing-arrow
            required: function required(value) {
              return (// eslint-disable-next-line implicit-arrow-linebreak
                Array.isArray(value) ? !!value.length || _this2.labels.ruleRequired : !!value || _this2.labels.ruleRequired
              );
            },
            email: function email(value) {
              if (!value) return true;
              var pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
              return pattern.test(value) || _this2.labels.ruleInvalidEMail;
            }
          };
        }
      },
      methods: _objectSpread({}, call('forms/*')),
      mounted: function mounted() {
        var _this3 = this;

        this.$nextTick(function () {
          if (window.digitalData.status !== 'complete') {
            window.digitalData.status = 'completed';
          }

          _this3.$store.commit('SET_COUNTRIES', _this3.countryList);
        });
      }
    });
  });
  components.forEach(function (component) {
    if (component.init) component.init();
  });
  setTimeout(function () {
    document.documentElement.classList.add('loaded');
  }, 300);
}

function checkWindowObjects() {
  // Hotfix for IE11
  if (windowObjectsExist()) {
    startApp();
  } else {
    var windowObjectInterval = setInterval(function () {
      if (windowObjectsExist()) {
        startApp();
        clearInterval(windowObjectInterval);
      }
    }, 1000);
  }
}

smoothscroll.polyfill();
document.addEventListener('DOMContentLoaded', checkWindowObjects);